module.exports = __webpack_public_path__ + "static/img/2_3_1.d4d23e86.jpg";